<template>
  <a-modal v-model="showModal" class="post-fullscreen" :closable="false" :footer="null" width="100%">
    <div class="mainContainer w-100 d-flex h-100" v-if="postData && postData.content_type === 'post'">
      <div class="leftSide hide-in-mobile">
        <Post :postData="postData" :showingFullScreen="showingFullScreen" v-if="showModal" />
      </div>
      <div class="rightSide">
        <div class="top position-relative" :style="{ height: postData.post_attach_url.length > 1 ? '83%' : '100%' }">
          <font-awesome-icon :icon="['fal', 'times']" class="cp rounded-circle hw20 p12 bg-white position-absolute xmark-icon" @click="hide" />
          <font-awesome-icon :icon="['far', 'chevron-left']" class="cp rounded-circle hw16 p14 bg-white position-absolute left-icon" @click="currentImageIndex--" v-if="currentImageIndex" />
          <font-awesome-icon
            :icon="['far', 'chevron-right']"
            class="cp rounded-circle hw16 p14 bg-white position-absolute right-icon"
            @click="currentImageIndex++"
            v-if="currentImageIndex < postData.post_attach_url.length - 1"
          />
          <div class="imgContainer flex-center-center position-relative bg-gray300">
            <template v-if="postData.post_attach_url[currentImageIndex].type">
              <img
                v-if="postData.post_attach_url[currentImageIndex].type.includes('image')"
                :src="postData.post_attach_url[currentImageIndex].url"
                :alt="postData.post_attach_url[currentImageIndex].name"
                loading="lazy"
              />
              <video v-if="postData.post_attach_url[currentImageIndex].type.includes('video')" :src="postData.post_attach_url[currentImageIndex].url" controls loading="lazy" />
            </template>
            <img v-else :src="postData.post_attach_url[currentImageIndex].url" :alt="postData.post_attach_url[currentImageIndex].name" loading="lazy" />
            <div v-if="postData.post_attach_url[currentImageIndex].sensitive" class="position-absolute flex-center-center flex-column h-100 w-100" :style="{ background: getSecondaryColor(), top: 0 }">
              <font-awesome-icon :icon="['fas', 'eye-slash']" class="mb-2 font-white hw54" />
              <h3 class="font-white font32 fw700 mb-2">Sensitive Content</h3>
              <p class="mb-4 font16 font-white text-center">This photo contains sensitive content which some people may find offensive or disturbing.</p>
              <div @click="() => (postData.post_attach_url[currentImageIndex].sensitive = false)" class="font-white fw700 font14 br6 p1224 cp" :style="{ background: getPrimaryColor() }">
                View Photo
              </div>
            </div>
          </div>
        </div>
        <div v-if="postData.post_attach_url.length > 1" class="bottom d-flex mx-2">
          <div v-for="(images, ind) in postData.post_attach_url" :key="images.name" class="position-relative cp" @click="() => (currentImageIndex = ind)">
            <template v-if="images.type">
              <img v-if="images.type.includes('image')" :src="images.resized_images ? images.resized_images.dov640x320 : images.url" :alt="images.name" class="eachBottomImage" />
              <video v-if="images.type.includes('video')" :src="images.url" class="eachBottomImage" />
            </template>
            <img v-else :src="images.resized_images ? images.resized_images.dov640x320 : images.url" :alt="images.name" class="eachBottomImage" />
            <div v-if="images.sensitive" class="position-absolute flex-center-center flex-column h-100 w-100" :style="{ background: getSecondaryColor(), top: 0 }">
              <font-awesome-icon :icon="['fas', 'eye-slash']" class="font-white hw54" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mainContainer w-100 d-flex h-100" v-if="postData && postData.content_type === 'question'">
      <div class="leftSide hide-in-mobile">
        <Question :quesData="postData" :showingFullScreen="showingFullScreen" v-if="showModal" />
      </div>
      <div class="rightSide">
        <div class="top position-relative" :style="{ height: postData.question_attach_url.length > 1 ? '83%' : '100%' }">
          <font-awesome-icon :icon="['fal', 'times']" class="cp rounded-circle hw20 p12 bg-white position-absolute xmark-icon" @click="hide" />
          <font-awesome-icon :icon="['far', 'chevron-left']" class="cp rounded-circle hw16 p14 bg-white position-absolute left-icon" @click="currentImageIndex--" v-if="currentImageIndex" />
          <font-awesome-icon
            :icon="['far', 'chevron-right']"
            class="cp rounded-circle hw16 p14 bg-white position-absolute right-icon"
            @click="currentImageIndex++"
            v-if="currentImageIndex < postData.question_attach_url.length - 1"
          />
          <div class="imgContainer flex-center-center position-relative bg-gray300">
            <template v-if="postData.question_attach_url[currentImageIndex].type">
              <img
                v-if="postData.question_attach_url[currentImageIndex].type.includes('image')"
                :src="postData.question_attach_url[currentImageIndex].url"
                :alt="postData.question_attach_url[currentImageIndex].name"
                loading="lazy"
              />
              <video v-if="postData.question_attach_url[currentImageIndex].type.includes('video')" :src="postData.question_attach_url[currentImageIndex].url" controls loading="lazy" />
            </template>
            <img v-else :src="postData.question_attach_url[currentImageIndex].url" :alt="postData.question_attach_url[currentImageIndex].name" loading="lazy" />
            <div
              v-if="postData.question_attach_url[currentImageIndex].sensitive"
              class="position-absolute flex-center-center flex-column h-100 w-100"
              :style="{ background: getSecondaryColor(), top: 0 }"
            >
              <font-awesome-icon :icon="['fas', 'eye-slash']" class="mb-2 font-white hw54" />
              <h3 class="font-white font32 fw700 mb-2">Sensitive Content</h3>
              <p class="mb-4 font16 font-white text-center">This photo contains sensitive content which some people may find offensive or disturbing.</p>
              <div @click="() => (postData.question_attach_url[currentImageIndex].sensitive = false)" class="font-white fw700 font14 br6 p1224 cp" :style="{ background: getPrimaryColor() }">
                View Photo
              </div>
            </div>
          </div>
        </div>
        <div v-if="postData.question_attach_url.length > 1" class="bottom d-flex mx-2">
          <div v-for="(images, ind) in postData.question_attach_url" :key="images.name" class="position-relative cp" @click="() => (currentImageIndex = ind)">
            <template v-if="images.type">
              <img v-if="images.type.includes('image')" :src="images.resized_images ? images.resized_images.dov640x320 : images.url" :alt="images.name" class="eachBottomImage" />
              <video v-if="images.type.includes('video')" :src="images.url" class="eachBottomImage" />
            </template>
            <img v-else :src="images.resized_images ? images.resized_images.dov640x320 : images.url" :alt="images.name" class="eachBottomImage" />
            <div v-if="images.sensitive" class="position-absolute flex-center-center flex-column h-100 w-100" :style="{ background: getSecondaryColor(), top: 0 }">
              <font-awesome-icon :icon="['fas', 'eye-slash']" class="font-white hw54" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import Post from "../../home/Post.vue"
import { faChevronRight, faChevronLeft } from "@fortawesome/pro-regular-svg-icons"
import { library } from "@fortawesome/fontawesome-svg-core"
import Question from "../../Users/Patient/QA/Question.vue"

library.add(faChevronLeft, faChevronRight)

export default {
  name: "PostFullScreen",
  props: { postData: Object },
  components: { Post, Question },
  data() {
    return { showModal: false, showingFullScreen: true, currentImageIndex: 0 }
  },
  created() {
    // console.log("(created) postData ->", this.postData)
  },
  methods: {
    show(d) {
      this.showModal = true
      this.postData = d
    },
    hide() {
      console.log("video ->", this.$el.querySelector("video"))
      console.log("videos ->", [...this.$el.querySelectorAll("video")])
      // this.$el.querySelector("video") && this.$el.querySelector("video").pause()
      this.showModal = false
    },
  },
  // mounted() {
  //   if (!showModal) {
  //     this.$el.querySelector("video") && this.$el.querySelector("video")[0].pause()
  //   }
  // },
}
</script>

<style lang="scss" scoped>
.leftSide {
  z-index: 1;
  max-width: 33.2%;
  flex-grow: 1;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
}
.rightSide {
  max-width: 66.8%;
  // height: 100vh;
  height: 100svh;
  // min-height: 100vh;
  // height: 100%;
  flex-grow: 2;

  @media screen and (max-width: 600px) {
    max-width: 100vw;
  }
}
.bottom {
  height: 17%;
  padding-top: 38px;
  padding-bottom: 21px;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media screen and (max-width: 600px) {
    padding-top: 24px;
  }
  // width: 100%;
  // justify-content: center;

  &::-webkit-scrollbar {
    // width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #e2e8f0;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #2a71d4;
    border-radius: 10px;
  }
}
.xmark-icon {
  top: 24px;
  right: 24px;
  z-index: 1;
}
.left-icon {
  z-index: 1;
  left: 24px;
  top: 50%;
  transform: translateY(-50%);
}
.right-icon {
  z-index: 1;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
}
.eachBottomImage {
  margin: 0 13px;
  object-fit: cover;
  // width: calc((100%- (3 * 26px) - (2 * 21px)) / 4);
  width: 210.5px;
  height: 100%;
  // height: 115px;
}
.imgContainer {
  height: 100%;
  img,
  video {
    width: 100%;
    object-fit: contain;
    height: 100%;
    // height: inherit;
    // width: inherit;
  }
}
@media screen and (max-width: 600px) {
  .text-center {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/activity/PostFullScreen.vue